import React, { useEffect } from "react";
// react-redux
import { useDispatch, useSelector } from "react-redux";
// react-router-dom
import { Link } from "react-router-dom";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ArrowRightOutlinedIcon from "@material-ui/icons/ArrowRightOutlined";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";

// styles
import styles from "./CategoryListStyle";
// action
import { fetchCategories } from "../../store/actions/WordPressApiAction";
const useStyles = makeStyles(styles);

/**
 * カテゴリーを表示する一覧
 * @param {*} props
 */
export default function CategoryList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const categoriesData = useSelector((state) => state.fetchCategoriesReducer);

  useEffect(() => {
    console.log("カテゴリーdispatch");
    dispatch(fetchCategories());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.categoryContainer}>
      <div className={classes.categoryHeader}>カテゴリー</div>
      <List className={classes.categoriesList}>
        {categoriesData.map((item) => (
          <div key={item.id}>
            <Link to={`/${item.name}/${item.id}`} className={classes.link}>
              <ListItem className={classes.subHeader} button>
                <div className={classes.subHeaderName}>
                  <ArrowRightOutlinedIcon className={classes.subHeaderIcon} />
                  {item.name}
                </div>
                <div className={classes.listCount}>{item.count}</div>
              </ListItem>
            </Link>
            {item.child.map((childItem) => (
              <Link
                to={`/${item.name}/${childItem.name}/${childItem.id}`}
                className={classes.link}
                key={childItem.id}
              >
                <ListItem
                  className={classes.listItem}
                  key={childItem.id}
                  button
                >
                  <div className={classes.listName}>
                    <NavigateNextOutlinedIcon
                      className={classes.listItemIcon}
                    />
                    {childItem.name}
                  </div>
                  <div className={classes.listCount}>{childItem.count}</div>
                </ListItem>
              </Link>
            ))}
          </div>
        ))}
      </List>
    </div>
  );
}
